<template>
  <a-modal
      centered
      :title="title"
      :width="800"
      @cancel="handleCancel"
      :visible="visible">
    <template slot="footer">
      <a-button @click="handleOk" type="primary">我已支付</a-button>
      <a-button @click="handleCancel">取消支付</a-button>
    </template>
    <div>
      <div style="padding: 20px 0 0 10px;width: 330px; float:left">
        <p style="margin-bottom: 15px;text-align:center;">充值金额<span class="red">{{modalData.amount}}</span>元</p>
        <p><img :src="modalData.qrCode" id="alipay-qrcode" style="border: 1px solid #b2b2b2;width: 328px;height: 328px"/></p>
      </div>
      <div style="float:right;padding-right: 25px;">
        <div v-show="this.modalData.type == '0'"><img :src="zf_images.zfb" /></div>
        <div v-show="this.modalData.type == '1'"><img :src="zf_images.wx" /></div>
      </div>
      <div style="clear: both"></div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "PayOrder",
  props: ['modalData'],
  data(){
    return{
      title : "账户充值支付页面",
      visible: false,
      zf_images:{
        zfb:require("@/assets/alipay_zf.jpg"),
        wx:require("@/assets/weixin_zf.jpg")
      }
    }
  },
  created() {

  },
  methods:{
    handleCancel(){
      this.visible = false;
    },//
    handleOk() {
      this.$emit('close');
      this.visible = false;
      //this.$router.push({name: 'report'});
    },
    close () {
      this.$emit('close');
      this.visible = false;
      // this.disableSubmit = false;
      // this.modalData.type = -1;
      // clearInterval(this.parent_timer);
      // this.parent_timer = null;
    }
  }
}
</script>

<style scoped>

</style>
